import { render, staticRenderFns } from "./RetencionShow.vue?vue&type=template&id=43e24f6c"
import script from "./RetencionShow.vue?vue&type=script&lang=js"
export * from "./RetencionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports